import { RiCalendarTodoLine } from "@itandi/itandi-bb-ui";
import { useState } from "react";
import { ScheduleInputModal } from "~/components/common/construction_schedule/ScheduleInputModal";
import { EditMenuButton } from "~/components/common/parts/button/EditMenuButton";
import { CONSTRUCTION_SCHEDULE_LABELS } from "~/constants/DealConstructionConst";
import type { Deal } from "~/models/Deal";
import {
	CONSTRUCTION_NUMBERS,
	getScheduleDisplay
} from "~/models/DealConstructionSchedule";
import {
	AWAITING_ACCEPTANCE,
	FINISHED,
	IN_CONSTRUCTION,
	PARTIALLY_FINISHED
} from "~/models/Status";
import Styles from "../DealCard.module.scss";

const DISPLAY_STATUSES = [
	IN_CONSTRUCTION,
	AWAITING_ACCEPTANCE,
	PARTIALLY_FINISHED,
	FINISHED
] as const;

type Props = {
	deal: Deal;
};

export function DealConstructionScheduleVendorCard({ deal }: Props) {
	const [isOpen, setIsOpen] = useState(false);

	if (!DISPLAY_STATUSES.some((s) => s === deal.statusId)) {
		return null;
	}

	return (
		<div className={Styles.DealCard}>
			<h3 className={Styles.Title}>
				<RiCalendarTodoLine className={Styles.TitleIcon} />
				工事日程
				{deal.statusId === IN_CONSTRUCTION ? (
					<div className={Styles.EditButtonWrapper}>
						<EditMenuButton
							onClick={() => {
								setIsOpen(true);
							}}
						>
							変更
						</EditMenuButton>
						{isOpen ? (
							<ScheduleInputModal
								deal={deal}
								handleClose={() => {
									setIsOpen(false);
								}}
							/>
						) : null}
					</div>
				) : null}
			</h3>
			<div className={Styles.Content}>
				{CONSTRUCTION_NUMBERS.map((typeNumber) => {
					const schedule = deal.dealConstructionSchedules.find(
						(s) => s.constructionScheduleType === typeNumber
					);
					const scheduleDisplay = getScheduleDisplay(schedule);
					return (
						<dl className={Styles.ListContent} key={typeNumber}>
							<dt className={Styles.ListContentCaption}>
								{CONSTRUCTION_SCHEDULE_LABELS[typeNumber]}
							</dt>
							<dd className={Styles.ListContentValue}>
								<span
									className={
										scheduleDisplay.state === "unregistered"
											? Styles.NotYet
											: undefined
									}
								>
									{scheduleDisplay.text}
								</span>
							</dd>
						</dl>
					);
				})}
			</div>
		</div>
	);
}
